module.exports = __webpack_public_path__ + "img/shubham.d65a23f3.jpg";